import validate from "/app/node_modules/.pnpm/nuxt@3.21.2_@biomejs+biome@2.4.8_@parcel+watcher@2.5.6_@vue+compiler-sfc@3.5.30_cac@6.7_d3bd1fa78bb531ea752a2ed112e7732b/node_modules/nuxt/dist/pages/runtime/validate.js";
import permission_45guard_45global from "/app/middleware/permission-guard.global.ts";
import role_45guard_45global from "/app/middleware/role-guard.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.2_@biomejs+biome@2.4.8_@parcel+watcher@2.5.6_@vue+compiler-sfc@3.5.30_cac@6.7_d3bd1fa78bb531ea752a2ed112e7732b/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  permission_45guard_45global,
  role_45guard_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_magicast@0.5.2_next-auth@4.21.1_next@13.5.11_@babel+core@7.2_79dedae5e634bb9c3103dfef0bb2c433/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}